/**
 * @description 通用的配置代码
 */

import axios from 'axios'
import { DEFAULT_TIMEOUT } from './constants.js'
import { createTraceId } from './common-utils.js'

// 所有请求将会有10秒的超时时间
axios.defaults.timeout = DEFAULT_TIMEOUT
axios.interceptors.request.use(function (config) {
  if (config.headers.traceId) {
    return config
  }
  config.headers.traceId = createTraceId()
  return config
})

// 设置全局的 Axios 默认配置
export function setAxiosDefaults(traceId: string) {
  axios.defaults.headers.common['traceId'] = traceId
}

/** polyfill BigInt toJSON, fix prisma: Do not know how to serialize a BigInt */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
BigInt.prototype.toJSON = function () {
  const int = Number.parseInt(this.toString())
  return int ?? this.toString()
}
